module.exports = __webpack_public_path__ + "img/banner.e23d6d54.png";